export const isCultureAndPopulated = (val: unknown): val is Culture => {
  const culture = val as Culture;

  return Boolean(
    Object.values(culture).every(
      (c) => !Number.isNaN(c) && typeof c === 'number',
    ),
  );
};
